// Las categorías del formulario llegan por props desde el `menu` del layout.

// Chequeo de formato de email. Debe funcionar igual en servidor y en cliente
// (el proyecto es ISR: este componente se renderiza también en el servidor,
// donde no existe `document`), así que no puede depender del DOM del navegador.
export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}

/** Longitud mínima (sin espacios en los extremos) de nombre y apellidos. */
export const NAME_MIN_LENGTH = 2

/**
 * Valida un campo de nombre/apellido. Vacío → `emptyMessage` (o '' si el campo es
 * opcional); más corto que `NAME_MIN_LENGTH` → mensaje de longitud con `fieldLabel`.
 */
export function validateNameField(value: string, fieldLabel: string, emptyMessage?: string): string {
  const length = value.trim().length
  if (length === 0) return emptyMessage ?? ''
  return length < NAME_MIN_LENGTH
    ? `${fieldLabel} debe tener al menos ${NAME_MIN_LENGTH} caracteres.`
    : ''
}
